import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { ROUTES } from "./constants";
import { protectedRoute } from "./helpers";

const HowToPage = lazy(() => import("@/features/howto"));

export const howToRoutes: RouteObject[] = [
	{
		path: ROUTES.HOW_TO,
		element: protectedRoute(<HowToPage />),
	},
];
